export default __webpack_public_path__ + "static/media/difference.b006ded6.svg";